<template>
<div id="room-delete-modal" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-sm mt-n3" role="dialog">
        <div class="modal-content modal-filled bg-danger">
            <div class="modal-body p-4">
                <div class="text-center">
                    <i class="ri-close-circle-line h1"></i>
                    <h4 class="mt-2">
                        주의하세요!
                    </h4>
                    <p class="mt-3">
                        방을 삭제하시면 <strong>"입실자 관리 내역"</strong>이 <br />모두 삭제됩니다.<br />
                        그래도 <strong>"{{ kosiwon_name }} 지점의 {{ room_name }}"</strong>을/를 삭제하시겠습니까?
                    </p>
                    <button type="button" class="btn btn-light my-2 me-1" data-bs-dismiss="modal">닫기</button>
                    <button type="button" class="btn btn-light my-2" @click="$emit('del-room')">확인</button>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    props: ["kosiwon_name", "room_name"]
}
</script>
